import { render, staticRenderFns } from "./DialogTodoDetail.vue?vue&type=template&id=66b323ff"
import script from "./DialogTodoDetail.vue?vue&type=script&lang=js"
export * from "./DialogTodoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports